import cn from "classnames";
import TabTemplate from "components/shared/profile/tab";
import { dateTimeToView, dateToView } from "helpers/date";
import {
    periodTypes,
    subscriptionStates,
    subscriptionStatesEnum,
    syncEntityStatuses,
    syncEntityStatusesEnum,
    tariffTypes,
} from "helpers/enums";
import { ending } from "helpers/i18n";
import { canManageOrganization, enumLabel, formatNumber } from "helpers/system";
import lowerFirst from "lodash/lowerFirst";
import React from "react";
import { getSubscriptions, syncOrganization } from "sources/billing";
import DataTable from "./dataTable";

export default class BillingTab extends TabTemplate {
    componentDidMount() {
        this.getData({});
    }

    getData = (reqParams) => {
        return getSubscriptions(reqParams).then((data) => {
            if (data) {
                this.setState({ data, isLoading: false });
            }
        });
    };

    renderSubscription = (item) => {
        const {
            currentPeriodEndDate,
            currentPeriodStartDate,
            id,
            periodLength,
            periodType,
            services,
            tariffType,
            description,
            state,
            tariffName,
            agreementName,
        } = item;

        const { price, multiplicator, totalPrice } = services[0] ?? {};
        return (
            <div key={id}>
                <div className="mb-3">
                    <h6 className="mb-0">{enumLabel(tariffTypes, tariffType)}</h6>
                    <div className="small font-italic text-muted">{description}</div>
                </div>
                <div className="table-border-with-radius mb-5">
                    <table className="table table-xs">
                        <tbody>
                            <tr>
                                <th className="pl-2 py-1">Договор</th>
                                <td className="text-right pr-2 py-1">{agreementName}</td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Статус</th>
                                <td
                                    className={cn("text-right pr-2 py-1", {
                                        "text-success": subscriptionStatesEnum.Active === state,
                                        "text-danger": [
                                            subscriptionStatesEnum.ProcessingError,
                                            subscriptionStatesEnum.Ended,
                                        ].includes(state),
                                        "text-primary": [
                                            subscriptionStatesEnum.Processing,
                                            subscriptionStatesEnum.Planned,
                                        ].includes(state),
                                    })}
                                >
                                    {enumLabel(subscriptionStates, state)}
                                </td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Стоимость подписки</th>
                                <td className="text-right pr-2 py-1">
                                    {formatNumber(totalPrice, { style: "currency", currency: "RUB" })}
                                </td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Кол-во подключенных машин</th>
                                <td className="text-right pr-2 py-1">{multiplicator}</td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Стоимость за 1 ед. техники в месяц</th>
                                <td className="text-right pr-2 py-1">
                                    {formatNumber(price, { style: "currency", currency: "RUB" })}
                                </td>
                            </tr>
                            {tariffName && (
                                <tr>
                                    <th className="pl-2 py-1">Тариф</th>
                                    <td className="text-right pr-2 py-1">{tariffName}</td>
                                </tr>
                            )}
                            <tr>
                                <th className="pl-2 py-1">Период оплаты</th>
                                <td className="text-right pr-2 py-1">
                                    Раз в {periodLength} {lowerFirst(enumLabel(periodTypes, periodType))}
                                    {ending(periodLength, "", "а", "ев")}
                                </td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Начало подписки</th>
                                <td className="text-right pr-2 py-1">{dateToView(currentPeriodStartDate)}</td>
                            </tr>
                            <tr>
                                <th className="pl-2 py-1">Окончание подписки</th>
                                <td className="text-right pr-2 py-1">{dateToView(currentPeriodEndDate)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    syncBilling = () => {
        this.setState({ isLoading: true });
        syncOrganization().then(() => this.getData({}));
    };

    renderBody = () => {
        const { billingMessage, inn, lanBillingLastSyncedAt, lanBillingSyncStatus, name } = this.state.data;
        const cname = cn("badge mr-1", {
            "badge-success": lanBillingSyncStatus === syncEntityStatusesEnum.Success,
            "badge-danger": lanBillingSyncStatus === syncEntityStatusesEnum.Failed,
        });
        return (
            <div className="row">
                <div className="col-sm-4">
                    <div className="card card-body">
                        <h5>{name}</h5>
                        <div>ИНН: {inn}</div>
                        {billingMessage && <small className="small font-italic text-muted">{billingMessage}</small>}
                        <div className="small">
                            Синхронизация: <br />
                            <span className={cname}>{enumLabel(syncEntityStatuses, lanBillingSyncStatus)}</span>{" "}
                            {dateTimeToView(lanBillingLastSyncedAt)}
                        </div>
                        {canManageOrganization(this.props.roles) && (
                            <div className="btn btm-sm btn-brand mt-3" onClick={this.syncBilling}>
                                Синхронизировать подписку
                            </div>
                        )}
                        <div className="mt-4">{this.state.data.subscriptions.map(this.renderSubscription)}</div>
                    </div>
                </div>
                <div className="col-sm-8">
                    <DataTable {...this.props} getData={this.getData} data={this.state.data} />
                </div>
            </div>
        );
    };
}
